import { useCallback } from "react";
import { NativeScrollEvent, NativeSyntheticEvent } from "react-native";
import { SharedValue, useSharedValue } from "react-native-reanimated";

const useHandleDragSelectionProviderScroll = (scrollOffset: SharedValue<number>) => {
	const isOverrideScrollingSV = useSharedValue(false);
	const handleScroll = useCallback(
		(event: NativeSyntheticEvent<NativeScrollEvent>) => {
			if (isOverrideScrollingSV.value) return;
			scrollOffset.value = event.nativeEvent.contentOffset.y;
		},
		[scrollOffset, isOverrideScrollingSV],
	);

	return {
		handleScroll,
		isOverrideScrollingSV,
	};
};
export default useHandleDragSelectionProviderScroll;
